import { IConfigSeller } from '@/models/configSeller'
import { motion } from 'framer-motion'
import { useSelector } from 'react-redux'
import Certificate from './components/Certificate'
import Checklist from './components/Checklist'
import Client from './components/Client'
import Contract from './components/Contract'
import Detail from './components/Detail'
import DeviceMobile from './components/DeviceMobile'
import DeviceOther from './components/DeviceOther'
import Discounts from './components/Discounts'
import Header from './components/Header'
import History from './components/History'
import Multimedia from './components/Multimedia'
import Questions from './components/Questions'
import { TradeinProvider } from './context/TradeinContext'
import { useTradeinContext } from './hooks/useTradeinContext'
import { webApiService } from '@/services'
import { IAppStore } from '@/models/store.model'
import { useAppDispatch } from '@/store/store'
import { updateUser } from '@/store/user'
import { useEffect } from 'react'
import { useParams } from 'react-router-dom'
import IAEvaluation from './components/IAEvaluation'

const TradeInPageContext = () => {
  const { ctx, saveCtx } = useTradeinContext()
  console.log('ctx => ', ctx)
  const configSeller = useSelector((store: { config: IConfigSeller }) => store.config)
  const isSamsungPeru = configSeller.config.s3.FOLDER_APP === 'ti_samsung_pe'
  const isFalabellaChile = configSeller.config.s3.FOLDER_APP === 'ti_falabella'
  const hasIAEvaluation = configSeller.config.permisos.ENABLE_IAEVALUATION === 1 && ctx.tradein.sbu === 'Smartphone'
  const userState = useSelector((store: IAppStore) => store.user)
  const dispatch = useAppDispatch()
  const { id } = useParams()
  const isNovabench = import.meta.env.VITE_ID_STORE_REMOVECHECKLIST !== '' && import.meta.env.VITE_ID_STORE_REMOVECHECKLIST !== undefined && import.meta.env.VITE_ID_STORE_REMOVECHECKLIST.split(',').includes(String(userState.id_store)) && isFalabellaChile && ctx.tradein.sbu === 'Notebook'

  const loadUSerStore = () => {
    saveCtx({ ...ctx, loading: true })
    webApiService.getStoreByUser(userState.id).then(res => {
      if (res.data.length > 0) {
        dispatch(updateUser({ ...userState, id_store: res.data[0].id }))
      }
    })
      .catch((error) => {
        saveCtx({ ...ctx, loading: false })
        console.log('Error loading data:', error)
      })
  }

  useEffect(() => {
    loadUSerStore()
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [id])

  return (
    <motion.div
      initial={{ y: 10, opacity: 0 }}
      animate={{ y: 0, opacity: 1 }}
      exit={{ y: -10, opacity: 0 }}
      transition={{ duration: 0.3 }} className='space-y-4'
    >
      <Header />
      <div className='grid grid-cols-12 gap-4 mt-4'>
        <div className='col-span-12 md:col-span-3'>
          <Detail />
        </div>
        <div className='col-span-12 md:col-span-9'>
          <Client />
          <div className='grid grid-cols-12 gap-4 mt-4'>
            <div className='col-span-12 md:col-span-8'>
              {ctx.tradein.sbu === 'Smartphone' || (ctx.tradein.sbu === 'Tablet' && ctx.tradein.brand === 'Apple') ? <DeviceMobile /> : <DeviceOther />}
            </div>
            <div className='col-span-12 md:col-span-4'>
              <History />
            </div>
          </div>
        </div>
      </div>
      <div className='grid grid-cols-12 gap-4 mt-4'>

        {ctx.tradein.id_status === 6 && (ctx.tradein.sbu === 'Smartphone' || (ctx.tradein.sbu === 'Tablet' && ctx.tradein.brand === 'Apple'))
          ? (
            <div className='col-span-12'><div className='text-sm p-4 bg-red-100 border border-red-300 rounded-md text-black'>Lo sentimos, este dispositivo no aprobó la evaluación de Phonecheck. Puede reenviar el código para realizar una nueva evaluación.</div></div>
            )
          : null}

        {
          ctx.tradein.id_status !== 6
            ? (
              <>
                <div className={configSeller.config.permisos.ENABLE_CHECK_BATTERY === 1 && (ctx.tradein.entry_form_status === 1 || ctx.tradein.certificate_theft === 'VALID') ? 'col-span-12 md:col-span-12' : 'col-span-12'}>
                  {ctx.tradein.sbu === 'Smartphone' || (ctx.tradein.sbu === 'Tablet' && ctx.tradein.brand === 'Apple')
                    ? <Certificate />
                    : <Checklist />}
                </div>

                {!isSamsungPeru &&
                  <div className='col-span-12'>
                    <Questions />
                  </div>}

                {!isSamsungPeru &&
                  <div className='col-span-12'>
                    {hasIAEvaluation ? <IAEvaluation /> : null}
                  </div>}

                {isSamsungPeru &&
                  <div className='col-span-12'>
                    <Questions />
                  </div>}

                {isSamsungPeru &&
                  <div className='col-span-12'>
                    <Discounts />
                  </div>}

                {isSamsungPeru &&
                  <div className='col-span-12'>
                    <Multimedia />
                  </div>}
                {/* {
                  configSeller.config.permisos.ENABLE_CHECK_BATTERY === 1 && (ctx.tradein.entry_form_status === 1 || ctx.tradein.certificate_theft === 'VALID')
                    ? (
                      <div className='col-span-12 md:col-span-6'>
                        <Discounts />
                      </div>
                      )
                    : null
                } */}
                {!isSamsungPeru && !isNovabench
                  ? (
                    <div hidden={hasIAEvaluation && ctx.tradein.grade_IA === null} className={ctx.tradein.id_status !== 1 ? 'col-span-12 md:col-span-6' : 'col-span-12'}>
                      <Discounts />
                    </div>
                    )
                  : null}

                {ctx.displayContract === 1 &&
                  <div className='col-span-6' hidden={hasIAEvaluation && ctx.tradein.grade_IA === null}>
                    <Contract />
                  </div>}
                {/* {
                  (ctx.displayContract === 0 && ctx.tradein.id_status === 4 && ctx.tradein.isBatteryHealthy !== null) || (ctx.tradein.id_status !== 1 && ctx.tradein.id_status !== 2 && ctx.tradein.id_status !== 4)
                    ? (<div className='col-span-12'>  <Multimedia /> </div>)
                    : null
                } */}

                {!isSamsungPeru &&
                  <div className='col-span-12' hidden={hasIAEvaluation && ctx.tradein.grade_IA === null}>
                    <Multimedia />
                  </div>}
              </>
              )
            : null
        }

      </div>
    </motion.div>
  )
}

const TradeInPage = () => {
  return (
    <TradeinProvider><TradeInPageContext /></TradeinProvider>
  )
}

export default TradeInPage
